import React from "react";

const IconPaperPlane = ({
  width = 28,
  height = 28,
  viewBox = "0 0 28 28",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="3.05176e-05" width="28" height="28" rx="6" fill="#4700D1" />
    <g clipPath="url(#clip0_1279_6345)">
      <path
        d="M19.4865 7.6903L19.4818 7.6921L7.37166 12.7016C7.26953 12.7434 7.17937 12.81 7.10924 12.8952C7.03911 12.9804 6.99121 13.0817 6.96981 13.19C6.94619 13.3034 6.95114 13.4209 6.9842 13.5319C7.01726 13.6429 7.0774 13.744 7.15921 13.826L9.42985 16.0966C9.54185 16.2085 9.6894 16.2779 9.84705 16.2927C10.0047 16.3075 10.1626 16.2669 10.2935 16.1778L15.8253 12.3725C15.8471 12.3576 15.8734 12.3508 15.8997 12.3533C15.926 12.3558 15.9506 12.3673 15.9693 12.386C15.9879 12.4047 15.9995 12.4293 16.002 12.4556C16.0044 12.4819 15.9977 12.5082 15.9828 12.53L12.1777 18.0616C12.0886 18.1924 12.0479 18.3502 12.0626 18.5078C12.0773 18.6654 12.1465 18.8129 12.2583 18.925L14.5293 21.196C14.6075 21.2743 14.7038 21.3319 14.8097 21.3638C14.9157 21.3956 15.0278 21.4006 15.1362 21.3784C15.2669 21.3521 15.3869 21.2878 15.4813 21.1936C15.5468 21.128 15.5985 21.05 15.6335 20.9642L20.663 8.87442L20.665 8.86881C20.7307 8.70407 20.7466 8.52369 20.7109 8.34997C20.6751 8.17626 20.5892 8.01684 20.4638 7.89143C20.3384 7.76602 20.179 7.68013 20.0053 7.64438C19.8316 7.60863 19.6512 7.6246 19.4865 7.6903Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1279_6345">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(6 6.00003)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default IconPaperPlane;
